"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sendCompany = _interopRequireDefault(require("../lists/sendCompany.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    SendCompany: _sendCompany.default
  },
  props: {
    itemLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sendLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    submitDisabled: function submitDisabled() {
      return this.skuTransportList.some(function (item) {
        var sendLists = item && item.sendLists ? item.sendLists : {};
        return !!sendLists.transportNo && !sendLists.companyValue;
      });
    }
  },
  watch: {
    sendLists: {
      handler: function handler() {
        var _this = this;
        var sendLists = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.skuTransportList = sendLists.length ? sendLists.map(function (item) {
          var _ids;
          var _ref = item || {},
            orderItemIds = _ref.orderItemIds,
            deliveryId = _ref.deliveryId,
            deliveryNo = _ref.deliveryNo,
            deliveryName = _ref.deliveryName,
            deliveryCode = _ref.deliveryCode;
          var ids = orderItemIds && orderItemIds.split(',') || [];
          ids = ids.length && ids.map(function (id) {
            return id && Number(id);
          });
          return {
            skuLists: _toConsumableArray(_this.itemLists),
            orderItemIdList: (_ids = ids) !== null && _ids !== void 0 && _ids.length ? ids : [],
            // 勾选的ID
            sendLists: {
              transportNo: deliveryNo,
              companyValue: deliveryId,
              initSearch: deliveryName,
              deliveryCode: deliveryCode // Pass the deliveryCode for company selection
            }
          };
        }) : [];
      },
      immediate: true,
      deep: true
    },
    skuTransportList: {
      handler: function handler() {
        this.$emit('submit-disabled-change', this.submitDisabled);
      },
      immediate: true,
      deep: true
    }
  },
  data: function data() {
    return {
      skuTransportList: []
    };
  },
  mounted: function mounted() {},
  methods: {
    // 提交数据
    handerSubmit: function handerSubmit() {
      return this.skuTransportList.map(function (item) {
        var _ref2 = item || {},
          _ref2$sendLists = _ref2.sendLists,
          sendLists = _ref2$sendLists === void 0 ? {} : _ref2$sendLists,
          _ref2$orderItemIdList = _ref2.orderItemIdList,
          orderItemIdList = _ref2$orderItemIdList === void 0 ? [] : _ref2$orderItemIdList;
        return _objectSpread(_objectSpread({}, sendLists), {}, {
          orderItemIds: orderItemIdList.length ? orderItemIdList.join(',') : ''
        });
      });
    },
    // 添加拆单物流信息
    addSkuCompany: function addSkuCompany() {
      this.skuTransportList.push({
        skuLists: _toConsumableArray(this.itemLists),
        orderItemIdList: [],
        // 勾选的ID
        sendLists: {
          transportNo: null,
          companyValue: null
        }
      });
    },
    // 删除拆单物流公司
    removeSkuCompany: function removeSkuCompany(row) {
      var _ref3 = this.detailInfo || {},
        _ref3$skuTransportLis = _ref3.skuTransportList,
        skuTransportList = _ref3$skuTransportLis === void 0 ? [] : _ref3$skuTransportLis;
      var idx = skuTransportList.length && skuTransportList.findIndex(function (item) {
        return item.id == row.id;
      });
      if (idx != -1) {
        var list = _toConsumableArray(row.sendLists || []);
        list.splice(idx, 1);
        this.$set(row, 'sendLists', list);
      }
      ;
    }
  }
};